import "phoenix_html"
import {Socket} from "phoenix"
import {LiveSocket} from "phoenix_live_view"
import {hooks as colocatedHooks} from "phoenix-colocated/moon_scan"
import topbar from "../vendor/topbar"
import {ARViewer} from "./ar_hook"
import {MosaicMap} from "./mosaic_hook"
import {ARSim} from "./ar_sim_hook"
import {PinMap as PinMapCore} from "./pin_map_hook"
import {MapTools, wrapPinMapForTouch} from "./map_touch_tools.js"
import {SectionMap} from "./section_map_hook.js"
import {RedactMap} from "./redact_map_hook.js"
import {VideoThumb} from "./video_thumb_hook.js"
import {CampaignAudioSync} from "./campaign_audio.js"
import {GLBPreview} from "./glb_preview_hook.js"
import AssetDrawer from "./asset_drawer.js"
import {PhotoCapture} from "./photo_capture_hook.js"

const PinMap = wrapPinMapForTouch(PinMapCore)

const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
const liveSocket = new LiveSocket("/live", Socket, {
  longPollFallbackMs: 2500,
  params: {_csrf_token: csrfToken},
  hooks: {
    ...colocatedHooks,
    ARViewer,
    ARSim,
    MosaicMap,
    PinMap,
    MapTools,
    SectionMap,
    RedactMap,
    VideoThumb,
    CampaignAudioSync,
    GLBPreview,
    AssetDrawer,
    PhotoCapture,
  },
})

topbar.config({barColors: {0: "#29d"}, shadowColor: "rgba(0, 0, 0, .3)"})
window.addEventListener("phx:page-loading-start", _info => topbar.show(300))
window.addEventListener("phx:page-loading-stop", _info => topbar.hide())

liveSocket.connect()

if (process.env.NODE_ENV === "development") {
  window.addEventListener("phx:live_reload:attached", ({detail: reloader}) => {
    reloader.enableServerLogs()
    let keyDown
    window.addEventListener("keydown", e => keyDown = e.key)
    window.addEventListener("keyup", _e => keyDown = null)
    window.addEventListener("click", e => {
      if(keyDown === "c"){
        e.preventDefault()
        e.stopImmediatePropagation()
        reloader.openEditorAtCaller(e.target)
      } else if(keyDown === "d"){
        e.preventDefault()
        e.stopImmediatePropagation()
        reloader.openEditorAtDef(e.target)
      }
    }, true)
    window.liveReloader = reloader
  })
}

window.liveSocket = liveSocket
